import { styled } from '@/stitches.config';

export const LogoWrapper = styled('div', {
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  zIndex: 1,
});
